export default __webpack_public_path__ + "static/isms-c00d4e5091d78c041e5549e4db09be7a.jpg";